import { useTranslation } from 'react-i18next';
import DateTime from '~/components/DateTime';
import Money from '~/components/Money';
import Button from '~/components/ui/Button';
import { SkeletonCard } from '~/components/ui/Skeleton';
import usePendingTransactions from '~/modules/subscription/usePendingTransactions';

function PendingTransactionsBlock() {
  const { t } = useTranslation('', { keyPrefix: 'subscription.pendingTransactions' });
  const { data: transactions, isLoading } = usePendingTransactions();

  if (!transactions?.data?.length) {
    return null;
  }

  return (
    <>
      {isLoading ? (
        <SkeletonCard height={186} />
      ) : (
        <div className="flex flex-col gap-2">
          <h4>{t('title')}</h4>
          <div className="flex flex-col gap-2">
            {transactions?.data.map((item) => (
              <div
                key={item.id}
                className="rounded-md bg-warning flex items-center py-2 px-4 border border-white/29 gap-4"
              >
                <Money value={item.amount} className="text-xs md:text-sm" />
                <DateTime value={item.date} className="text-xs md:text-sm" />
                {/* <div className="bg-white/15 py-1 px-2 rounded-sm capitalize text-sm">{item.status}</div> */}

                {item.payment_url && (
                  <Button
                    variant="outlined"
                    size="xs"
                    className="ml-auto"
                    onPress={() => window.open(item?.payment_url || '', '_blank')}
                  >
                    {t('view')}
                  </Button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default PendingTransactionsBlock;
